import * as React from "react";
import { useState, useEffect } from "react";
import setAuthToken from "../../auth/auth.js";
import "../Styles/style.css";
import logo from "../../images/fame-wheels-logo.png";
import Box from "@mui/material/Box";
import { NavLink, Link } from "react-router-dom";
import DynamicFeedOutlinedIcon from "@mui/icons-material/DynamicFeedOutlined";
import Button from "@mui/material/Button";
import BottomNavigation from "@mui/material/BottomNavigation";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import InspectionIcon from "../../images/inspectionIcon.png";
import InspectionOrders from "../../images/inspection-orders.png";
import jwtDecode from "jwt-decode";
import { useAuthContext } from "../../hooks/useAuthContext.js";
import Cookies from "js-cookie";
import { AuthContext } from "../../context/AuthContext.js";
import PakistanFlag from "../../images/pakistan.png";

export default function Header() {
  const token = localStorage.getItem("token");

  const { dispatch } = useAuthContext();
  const { user } = React.useContext(AuthContext);
  const [isOnline, setIsOnline] = useState(true);
  const [isSessionExpired, setIsSessionExpired] = useState(false);
  const [bottomValue, setBottomValue] = React.useState(0);

  useEffect(() => {
    const handleConnectionChange = () => {
      setIsOnline(window.navigator.onLine);
    };

    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);

    handleConnectionChange();

    return () => {
      window.removeEventListener("online", handleConnectionChange);
      window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
      if (decodedToken.exp < currentTime) {
        // Token has expired
        setIsSessionExpired(true);
      }
    } else {
      // Token is missing, handle accordingly (e.g., log the user out)
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("data");
    setAuthToken(null);
    Cookies.remove("%2515M%25");
    dispatch({ type: "LOGOUT", payload: null });
    window.location.reload();
  };

  return (
    <div>
      {isSessionExpired && (
        <div
          className="text-center py-3"
          style={{ backgroundColor: "#0434bb" }}
        >
          <p className="mb-0 color-white">
            Your session has timed out. Please log in again.{" "}
            <a className="color-white fw-700" onClick={handleLogout} href="/">
              Refresh
            </a>
          </p>
        </div>
      )}
      {!isOnline && (
        <div
          className="text-center py-1"
          style={{ backgroundColor: "#0434bb" }}
        >
          <p className="mb-0 color-white">
            You are currently offline. Please check your internet connection.
          </p>
        </div>
      )}
      <div className="bgSecondary">
        <div className="container d-flex justify-content-between align-items-center flex-nowrap px-2 m-auto py-1">
          <div className="d-flex justify-content-start align-items-center callUs text-white ">
            <h5 className="pe-2 m-0 fw-300">
              <img
                style={{ height: "16px" }}
                className="me-2 "
                src={PakistanFlag}
                alt="pakistan flag"
                srcSet=""
              />
              Pakistan
            </h5>
          </div>
          <div className="">
            <div className="d-flex justify-content-end preHeader_authBtns">
              {user && user ? (
                <>
                  <div className="userDetails">
                    <p className="m-0 dropdown-toggle fw-500 text-capitalize">
                      Welcome! <b>{user?.name}</b>
                    </p>
                    <ul className="userDetails-subMenu ps-2 py-2">
                      <li onClick={handleLogout}>
                        <Link className="w-100 d-block" to="">
                          <i className="fa-solid fa-arrow-right-from-bracket pe-2"></i>
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <p className="m-0 px-2 d-none d-md-block">|</p>
                </>
              ) : (
                " "
              )}
              {user && user ? (
                <>
                  <div className="userDetails">
                    {user?.role_id === 5 ? (
                      <p className="m-0 fw-600">Vehicle Inspector</p>
                    ) : (
                      <Link to="/become-a-member">
                        <p className="m-0 fw-600">Become a member</p>
                      </Link>
                    )}
                  </div>
                </>
              ) : null}

              {user && (
                <button
                  className="btn p-0 me-2 fw-300 d-md-none"
                  onClick={handleLogout}
                >
                  <i className="fa-solid fa-arrow-right-from-bracket pe-2"></i>
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <nav className=" responseTab container m-auto flex-column navbar navbar-expand-lg navbar-light pb-2 py-0 pt-2 py-md-3">
        <div className="w-100 d-lg-none">
          <Link className="navbar-brand m-0" to="/">
            <img className="FW-logo" src={logo} alt="Famewheels" />
          </Link>
        </div>
        <div className="w-100 w-md-unset d-response">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <Link className="navbar-brand" to="/">
            <img
              className="FW-logo"
              src={logo}
              alt="FameWheels - Car Live Bidding and Cars for sale in Pakistan"
            />
          </Link>
          <div
            className="collapse navbar-collapse me-4"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav m-auto mt-3 mb-lg-0 fw-navbar justify-content-around  w-100">
              {user?.role_id === 1 || user?.role_id === 5 ? (
                <>
                  <li className="nav-item dropdown serviceDrop-main">
                    <NavLink
                      to="/car-inspection"
                      className="nav-link "
                      activeClassName="active"
                    >
                      <p className="nav-link pad-0 dropdown-toggle m-0 serviceDrop">
                        Car Inspection
                      </p>
                    </NavLink>
                    <ul className="Services-subMenu ps-3 py-3">
                      <li>
                        <NavLink
                          to="/search-inspection"
                          activeClassName="active"
                        >
                          <img
                            src={InspectionIcon}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Inspection History
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/car-inspection" activeClassName="active">
                          <img
                            src={InspectionIcon}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Book Inspection
                        </NavLink>
                      </li>

                      <li>
                        <NavLink to="/offline-draft" activeClassName="active">
                          <img
                            src={InspectionIcon}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Offline Draft
                        </NavLink>
                      </li>

                      <li>
                        <NavLink to="/offline-orders" activeClassName="active">
                          <img
                            src={InspectionIcon}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Offline Orders
                        </NavLink>
                      </li>

                      <li>
                        <Link to="/syncoffline">
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Offline Sync
                        </Link>
                      </li>

                      <li>
                        <NavLink
                          to="/inspection-orders"
                          activeClassName="active"
                        >
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          My Pending Orders{" "}
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/my-orders" activeClassName="active">
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcSet=""
                          />
                          My Inspections
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/inspection-history"
                          activeClassName="active"
                        >
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Inspection Reports
                        </NavLink>
                      </li>

                      <li>
                        <NavLink
                          to="/bidding-inspection-reports"
                          activeClassName="active"
                        >
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Bidding Inspection Reports
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/inspection-draft"
                          activeClassName="active"
                        >
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Inspection Draft
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/short-inspection-reports"
                          activeClassName="active"
                        >
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcset=""
                          />
                          Shor Inspection Report
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              ) : null}
            </ul>
          </div>
        </div>
      </nav>

      <Box className="position-fixed bottomNavigation bottom-0 w-100 bg-white bottomNagivation_res ">
        <div className="bottomArea">
          <BottomNavigation
            showLabels
            value={bottomValue}
            onChange={(event, newValue) => {
              setBottomValue(newValue);
            }}
            className=" align-items-center Nav-Btns w-100 justify-content-between position-relative"
          >
            {user?.role_id === 5 && (
              <Link to="/inspection-orders">
                <Button variant="text" className=" text-capitalize flex-column">
                  <DynamicFeedOutlinedIcon />
                  My Pending Orders
                </Button>
              </Link>
            )}

            {user?.role_id === 5 && (
              <Button
                variant="text"
                className=" text-capitalize flex-column"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
              >
                <MenuRoundedIcon />
                More
              </Button>
            )}

            <div
              className="offcanvas offcanvas-start w-75"
              tabIndex="-1"
              id="offcanvasExample"
              aria-labelledby="offcanvasExampleLabel"
            >
              <div className="offcanvas-header">
                <a className="navbar-brand" href="/">
                  <img
                    className="FW-drawer-logo"
                    src={logo}
                    alt="Fame Wheels"
                  />
                </a>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div className="offcanvas-body">
                <div className="fwDrawer">
                  <ul className="position-relative ">
                    {user && user?.role_id !== 5 ? (
                      <div>
                        <li>
                          <a href="/car-inspection">
                            <img
                              src={InspectionIcon}
                              className="membertick m-0 me-2"
                              alt=""
                              srcSet=""
                            />
                            Car Inspection
                          </a>
                        </li>
                      </div>
                    ) : user?.role_id === 5 ? (
                      <></>
                    ) : (
                      <div>
                        {user?.role_id === 1 || user?.role_id === 2 ? (
                          <li>
                            <a href="/become-a-member">
                              <i className="fa-solid fa-plus pe-2"></i>Become a
                              member
                            </a>
                          </li>
                        ) : user?.role_id === 3 ? (
                          <></>
                        ) : (
                          <li>
                            <a href="/become-a-member">
                              <i className="fa-solid fa-plus pe-2"></i>Become a
                              member
                            </a>
                          </li>
                        )}

                        <li>
                          <a href="/used-cars">
                            <i className="fa-solid fa-car pe-2"></i>Used Cars
                          </a>
                        </li>
                        <li>
                          <a href="/new-cars">
                            <i className="fa-solid fa-car pe-2"></i>New Cars
                          </a>
                        </li>
                        <li>
                          <a href="/car-inspection">
                            <img
                              src={InspectionIcon}
                              className="membertick m-0 me-2"
                              alt=""
                              srcSet=""
                            />
                            Car Inspection
                          </a>
                        </li>
                        <li>
                          <a href="/bidding">
                            <i className="fa-solid fa-arrow-trend-up pe-2"></i>
                            Live Bidding
                          </a>
                        </li>
                        <li>
                          <a href="/upcomming">
                            <i className="fa-brands fa-hive pe-2"></i>Upcoming
                            Bidding
                          </a>
                        </li>
                      </div>
                    )}
                    {user && user?.role_id === 5 && (
                      <li data-bs-dismiss="offcanvas" aria-label="Close">
                        <Link to="/profile">
                          <img
                            src={InspectionOrders}
                            className="membertick m-0 me-2"
                            alt=""
                            srcSet=""
                          />
                          My Profile{" "}
                        </Link>
                      </li>
                    )}

                    {user && user?.role_id === 5 && (
                      <>
                        <li>
                          <a href="/car-inspection">
                            <img
                              src={InspectionIcon}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Book Inspections
                          </a>
                        </li>
                        <li>
                          <Link to="/search-inspection">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Search Inspection History
                          </Link>
                        </li>
                        <h6 className="fw-bold fs-5 text-danger">
                          Offline Inspections
                        </h6>

                        <li>
                          <Link to="/offline-orders">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Offline Orders
                          </Link>
                        </li>

                        <li>
                          <Link to="/offline-draft">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Offline Draft
                          </Link>
                        </li>

                        <li>
                          <Link to="/syncoffline">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Offline Sync
                          </Link>
                        </li>

                        <h6 className="fw-bold fs-5 text-danger">
                          Online Inspections
                        </h6>

                        <li>
                          <Link to="/inspection-orders">
                            <img
                              src={InspectionIcon}
                              className="membertick m-0 me-2"
                              alt=""
                              srcSet=""
                            />
                            New Orders
                          </Link>
                        </li>
                        <li data-bs-dismiss="offcanvas" aria-label="Close">
                          <Link to="/my-orders">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcSet=""
                            />
                            My Pending Orders{" "}
                          </Link>
                        </li>
                      </>
                    )}
                    {user?.role_id === 5 || user?.role_id === 1 ? (
                      <>
                        <li>
                          <Link to="/inspection-draft">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            My Draft
                          </Link>
                        </li>

                        <li data-bs-dismiss="offcanvas" aria-label="Close">
                          <Link to="/inspection-history">
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcSet=""
                            />
                            My Completed Orders
                          </Link>
                        </li>

                        <h6 className="fw-bold fs-5 text-danger">
                          Bidding Inspections
                        </h6>
                        <li>
                          <NavLink
                            to="/bidding-pending-orders"
                            activeClassName="active"
                          >
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Bidding Pending Orders
                          </NavLink>
                        </li>

                        <li>
                          <NavLink
                            to="/bidding-inspection-draft"
                            activeClassName="active"
                          >
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Bidding Inspection Draft
                          </NavLink>
                        </li>

                        <li>
                          <NavLink
                            to="/bidding-inspection-reports"
                            activeClassName="active"
                          >
                            <img
                              src={InspectionOrders}
                              className="membertick m-0 me-2"
                              alt=""
                              srcset=""
                            />
                            Bidding Inspection Reports
                          </NavLink>
                        </li>
                      </>
                    ) : null}
                  </ul>
                  <div className="mt-auto">
                    {user && user ? (
                      <>
                        <div className="bgSecondary  px-3 py-3 rounded m-0 w-100">
                          <p className="m-0 fs-6 fw-700 color-white ">
                            <i className="fa-solid fa-user pe-2 fs-6"></i>
                            {user?.name}
                          </p>
                        </div>
                      </>
                    ) : (
                      " "
                    )}
                  </div>
                </div>
              </div>
            </div>
          </BottomNavigation>
        </div>
      </Box>
    </div>
  );
}
